import { Resources } from "@app/resources";
import { HomeControllerComponent } from './pages/home-controller/home-controller.component';
import { ThreedControllerComponent } from './pages/threed-controller/threed-controller.component';

export default {
  path: Resources.SmartController,
  children: [
    {
      path: Resources.HomeController,
      component: HomeControllerComponent,
    },
    {
      path: Resources.ThreeDController,
      component: ThreedControllerComponent,
    },
  ]
}
